import React, { useId } from 'react';

const CalendarIcon = ({ size = 16, color = '#767673', className = '', title, ...rest }) => {
    const clipPathId = useId();

    return (
        <svg
            width={size}
            height={size}
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
            role={title ? 'img' : 'presentation'}
            aria-hidden={title ? undefined : true}
            focusable='false'
            {...rest}
        >
            {title && <title>{title}</title>}
            <g clipPath={`url(#${clipPathId})`}>
                <path d='M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z' stroke={color} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M11 1.5V3.5' stroke={color} strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M5 1.5V3.5' stroke={color} strokeWidth='1.4' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M2.5 5.5H13.5' stroke={color} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
            </g>
            <defs>
                <clipPath id={clipPathId}>
                    <rect width='16' height='16' fill='white' />
                </clipPath>
            </defs>
        </svg>
    );
};

export default CalendarIcon;
